import React from 'react';

const initDataLayerObject = pageType => {
  let env = process.env.ENVIRONMENT;
  switch (env) {
    case "development":
      env = 'DEV';
      break;
    case "test":
      env = 'QA';
      break;
    case "production":
    case "prod":
      env = 'PROD';
      break;
    default:
      env = 'DEV';
  }
  let breadcrumb = [];
  if (typeof window !== 'undefined') {
    // Store the current page type in sessionStorage and load the previous ones.
    breadcrumb = JSON.parse(sessionStorage.getItem('breadcrumb')) || [];
    sessionStorage.setItem('breadcrumb', JSON.stringify(breadcrumb));
  }
  return {
    environment: env.toUpperCase(),
      country: process.env.REACT_APP_COUNTRY.toUpperCase(),
    type: pageType,
    breadcrumb: breadcrumb,
    search_results: {
    search_result_amount: 0,
      search_result_distance: 0,
      search_result_page: 0,
      search_result_zip_code: '',
      search_result_keyword: '',
    }
  };
};

const pushBranchPageVisited = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'eventCategory': '[H] General',
    'eventAction': '[H] Branch Search',
    'eventLabel': '[H] Branch Page Visited',
    'event': 'eventTracker',
  });
}

const generateDataLayer = (pageType, locale) => {
  return handlePress(pageType, locale);
};

const handlePress = (pageType, locale) => {
  // Page.
  const page = initDataLayerObject(pageType);
  page.language = locale;

  return {
    page
  }
};

export {generateDataLayer, pushBranchPageVisited}
